import React from 'react';
import { Wordmark } from '../../containers/Home/parts';

const pill = { position: 'absolute', borderRadius: 7 };

const Splash = ({ leaving }) => {
  return (
    <main className={`screen splash${leaving ? ' splash-out' : ''}`} aria-busy="true" style={{ background: '#4b1d52', color: '#fff6e0', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div aria-hidden="true" style={{ position: 'absolute', inset: 0, overflow: 'clip' }}>
        <div className="splash-rays"></div>
      </div>
      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <span className="splash-pill" aria-hidden="true" style={{ ...pill, top: 40, right: -34, width: 44, height: 14, background: '#7fe0b5', transform: 'rotate(-24deg)' }}></span>
        <span className="splash-pill" aria-hidden="true" style={{ ...pill, top: 10, left: -20, width: 14, height: 14, background: '#ee5a4a' }}></span>
        <span className="splash-pill" aria-hidden="true" style={{ ...pill, bottom: -54, left: -30, width: 44, height: 14, background: '#ee5a4a', transform: 'rotate(18deg)' }}></span>
        <span className="splash-pill" aria-hidden="true" style={{ ...pill, bottom: -36, right: 6, width: 14, height: 14, background: '#fff6e0' }}></span>
        <span className="splash-pill" aria-hidden="true" style={{ ...pill, top: 150, right: -44, width: 14, height: 14, background: '#fff6e0' }}></span>
        <svg className="splash-fan" width="200" height="150" viewBox="0 0 200 150" aria-hidden="true">
          <g transform="rotate(-14 74 76)">
            <rect x="34" y="20" width="80" height="112" rx="12" fill="#24102a" stroke="#fff6e0" strokeWidth="3"></rect>
            <circle cx="47" cy="61" r="4.2" fill="#fff6e0"></circle>
            <circle cx="61" cy="61" r="4.2" fill="#fff6e0"></circle>
            <path d="M48 76l6 14.5 6-14.5" fill="none" stroke="#fff6e0" strokeWidth="5.6" strokeLinecap="round" strokeLinejoin="round"></path>
          </g>
          <g transform="rotate(12 126 70)">
            <rect x="86" y="14" width="80" height="112" rx="12" fill="#fff6e0" stroke="#24102a" strokeWidth="3"></rect>
            <circle cx="113" cy="50" r="5.6" fill="#24102a"></circle>
            <circle cx="139" cy="50" r="5.6" fill="#24102a"></circle>
            <rect x="105" y="72" width="42" height="9" rx="4.5" fill="#ee5a4a"></rect>
          </g>
        </svg>
        <div className="splash-box">
          <div style={{ font: '400 76px/1 var(--display)', textAlign: 'center', color: '#fff6e0' }}><Wordmark accent="#7fe0b5" /></div>
        </div>
      </div>
    </main>
  );
};

export default Splash;
